import { render, staticRenderFns } from "./Watches.vue?vue&type=template&id=78727466"
import script from "./Watches.vue?vue&type=script&lang=js"
export * from "./Watches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports